import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { BACKEND_URL } from "../data/config";

const Login = ({ setIsAuthenticated }) => {
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.username || !formData.password) {
      setError('Veuillez remplir tous les champs');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        `${BACKEND_URL}/api/auth.php`,
        formData,
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.data.success) {
        localStorage.setItem('token', 'logged-in');
        localStorage.setItem('user', JSON.stringify(response.data.user));
        setIsAuthenticated(true);
        navigate('/dashboard');
      } else {
        setError(response.data.message || 'Identifiants incorrects');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f5f7fb] flex items-center justify-center px-4">
      <div className="w-full max-w-xl">
        <div className="bg-white rounded-3xl shadow-xl px-10 py-12 border border-gray-100">
          {/* Logo + titre */}
          <div className="flex flex-col items-center mb-10">
            {/* Remplace ce bloc par ton vrai logo si tu en as un */}
            <div className="mb-4">
              <img src="/VideekoLogo.png" alt="VIDEEKO VANILLA SARLU" className='h-16' />
            </div>
            <h1 className="text-2xl font-semibold text-gray-800">
              Sign in to your account
            </h1>
            <p className="mt-2 text-xs text-gray-400 tracking-wide">
              Attendance Tracking System
            </p>
          </div>

          {/* Formulaire */}
          <form onSubmit={handleSubmit} className="space-y-5 text-start">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Email address
              </label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-400"
                placeholder="admin@example.com"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Password
              </label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="w-full rounded-lg border border-gray-200 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-400"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full mt-2 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium py-2.5 transition disabled:opacity-60"
            >
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </form>

          {/* Bas de carte */}
          <div className="mt-8 flex items-center justify-center text-xs text-gray-400">
            <span className="h-px w-10 bg-gray-200 mr-3" />
            <span>Secure Login</span>
            <span className="h-px w-10 bg-gray-200 ml-3" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
